import {Pipe, PipeTransform} from '@angular/core';
import {AdminService} from "../../admin/services/admin.service";

@Pipe({
    name: 'human',
    standalone: true
})
export class HumanPipe implements PipeTransform {
  constructor(
    private adminService: AdminService
  ) {
  }
  transform(value: string, style?: string, default_value?: string, mode = 'singular') {
    return this.adminService.getText(value, style, default_value, mode);
  }
}
